module.exports = __webpack_public_path__ + "img/generic-error.3b035b07.png";